/* Pharmesthetic JAPAN — Membership Program
   scroll reveal + quicknav active state
   ------------------------------------------------------- */
(function () {
  'use strict';

  var REVEAL_SELECTOR = [
    '.pjms-section-header',
    '.pjms-card',
    '.pjms-tier-card',
    '.pjms-tier-note',
    '.pjms-subhead',
    '.pjms-custom-table-container',
    '.pjms-footnote',
    '.pjms-reward-card',
    '.pjms-step-card',
    '.pjms-points-cta',
    '.pjms-screenshot-wrap > *'
  ].join(',');

  var io = null;

  function getObserver() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('pjms-is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return io;
  }

  function initReveal(scope) {
    var root = scope || document;
    var targets = root.querySelectorAll(REVEAL_SELECTOR);
    if (!targets.length) return;

    Array.prototype.forEach.call(targets, function (el) {
      if (!el.classList.contains('pjms-reveal')) el.classList.add('pjms-reveal');
    });

    ['.pjms-overview-grid', '.pjms-tier-grid', '.pjms-reward-grid', '.pjms-step-grid'].forEach(function (sel) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), function (grid) {
        Array.prototype.forEach.call(grid.children, function (child, i) {
          if (i > 0 && i < 5) child.classList.add('pjms-d' + i);
        });
      });
    });

    var obs = getObserver();
    if (!obs) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('pjms-is-in'); });
      return;
    }
    Array.prototype.forEach.call(targets, function (el) {
      if (!el.classList.contains('pjms-is-in')) obs.observe(el);
    });
  }

  var ticking = false;

  function updateNav() {
    var nav = document.querySelector('.pjms-quicknav');
    if (!nav) return;
    nav.classList.add('pjms-nav-show');

    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;
    var idx = -1;
    links.forEach(function (a, i) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var s = document.getElementById(id);
      if (!s) return;
      var top = s.getBoundingClientRect().top + window.scrollY;
      if (window.scrollY >= top - 140) idx = i;
    });
    if (idx < 0) idx = 0;
    links.forEach(function (a, i) { a.classList.toggle('pjms-active', i === idx); });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { updateNav(); ticking = false; });
  }

  function boot(scope) {
    initReveal(scope);
    updateNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target) {
      e.target.classList.add('pjms-is-in');
      var p = e.target.closest ? e.target.closest('.pjms-reveal') : null;
      if (p) p.classList.add('pjms-is-in');
    }
  });
})();
